import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { formatterDate, IVModeOptions, IVTypeOptions, MultipleMonthOptions, normativa, optionsFormatter, OptionType, SingleMonthOptions } from '../../../../utils'
import { GetAllPac, resetGetAllPACsStatus, setPACDetailsUpdateNote, setPACDetailUpdateAnnualControlPlaneId, setPACDetailUpdateMode, setPACDetailUpdatePeriodicity, setPACDetailUpdateSampling, setPACDetailUpdateSpecifications, setPACDetailUpdateVisitingType } from '../slice'
import '../styles.scss'
import { periodicityValueGenerator } from '../utils'

export function EditPACForms() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)
    const [pacOptions, setPacOptions] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(GetAllPac(pacState.getAllPACsFilters))
    }, [])

    useEffect(() => {
        if (pacState.getAllPACsStatus === 'successfully' &&
            pacState.getAllPACsResponse !== undefined
        ) {
            dispatch(resetGetAllPACsStatus())
            const data = pacState.getAllPACsResponse.data.filter(pac => pac.norm === pacState.PACDetailNorm).map(pac => {
                return {
                    value: pac.id,
                    label: `Anno rif. ${pac.year} - ${optionsFormatter(pac.norm!, normativa)} - Valido dal ${formatterDate(pac.startingDate)} al ${formatterDate(pac.endingDate)}`
                } as OptionType
            })
            setPacOptions(data)
        }
    }, [pacState.getAllPACsStatus])

    return (
        <div className="flex flex-col gap-6 p-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">PAC / Scegli riferimento PAC</span>
                </div>
                <div className="p-6">
                    <MadfarmStaticSelect
                        noOptionsMessage=''
                        error={pacState.PACDetailErrors.annualControlPlaneId}
                        errorLabel='Riferimento mancante'
                        placeholder={'Seleziona riferimento...'}
                        options={pacOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setPACDetailUpdateAnnualControlPlaneId(newValue))
                        }}
                        value={pacState.PACDetailUpdateRequest.annualControlPlaneId}
                    />
                </div>
            </div>

            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">PAC / Dettagli</span>
                </div>
                <div className='flex flex-col gap-6 p-6'>
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            label="Periodo"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.periodicity}
                            errorLabel='Periodicità mancante'
                            placeholder={'Seleziona periodo...'}
                            options={
                                pacState.PACDetailNorm !== 'NORMA_BIO'
                                    ? MultipleMonthOptions
                                    : SingleMonthOptions
                            }
                            value={periodicityValueGenerator(pacState.PACDetailUpdateRequest.periodicity!)}
                            onChange={(val) => {
                                const option = val as unknown as { value: string, label: string } | null

                                const newValue = option?.value || null

                                if (newValue) {
                                    dispatch(setPACDetailUpdatePeriodicity(
                                        newValue.split('-').map((v: string) => Number(v))
                                    ))
                                } else {
                                    dispatch(setPACDetailUpdatePeriodicity([]))
                                }
                            }}
                        />
                        <MadfarmStaticSelect
                            label="Modalità"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.mode}
                            errorLabel='Modalità mancante'
                            placeholder={'Seleziona modalità...'}
                            options={IVModeOptions}
                            value={pacState.PACDetailUpdateRequest.mode}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailUpdateMode(newValue))
                            }}
                        />
                    </div>
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            label="Tipo Visita"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.visitType}
                            errorLabel='Tipologia mancante'
                            placeholder={'Seleziona tipo...'}
                            options={IVTypeOptions}
                            value={pacState.PACDetailUpdateRequest.visitType}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailUpdateVisitingType(newValue))
                            }}
                        />
                        <MadfarmStaticSelect
                            label="Prelievo"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.sampling}
                            errorLabel='Prelievo mancante'
                            placeholder={'Seleziona prelievo...'}
                            options={[{ value: 'Sì', label: 'Sì' }, { value: 'No', label: 'No' }]}
                            value={pacState.PACDetailUpdateRequest.sampling ? 'Sì' : 'No'}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailUpdateSampling(newValue === 'Sì'))
                            }}
                        />
                    </div>
                    <TextArea
                        label="Specifiche"
                        value={pacState.PACDetailUpdateRequest.specifications}
                        onChangeText={(value) => dispatch(setPACDetailUpdateSpecifications(value))}
                    />
                    <TextArea
                        label="Note"
                        value={pacState.PACDetailUpdateRequest.note}
                        onChangeText={(value) => dispatch(setPACDetailsUpdateNote(value))}
                    />
                </div>
            </div>
        </div>
    )
}